import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, UserService } from '../../shared';

@Component({
  selector: 'app-security1',
  templateUrl: './security1.component.html',
  styleUrls: ['../style.component.css', './security1.component.css']
})
export class Security1Component implements OnInit {
  public Select = {
    quest1: "",
    quest2: "",
    quest3: "",
    answer1: "",
    answer2: "",
    answer3: ""
  }
  accid: any;
  ansvalue: any;
  public timealert = environment.timelimit;
  answer: any;
  security: any = [];
  patid: any;
  welcome: any;
  modalRef: any;
  resdata: any;
  mail = window.localStorage['mail']

  constructor(
    private patientservice: PatientService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private userService: UserService,
    private nav: Router
  ) { }

  ngOnInit() {
    this.patientservice.getsecurity(this.mail).subscribe(
      data => {
        if (data) {
          this.security = data[0].secQuestionName;
          this.patid = data[0].secQuestionId;
          this.answer = data[0].secAnswer;
          this.accid = data[0].userAccountId
        }
      }
    );
  }

  ques(qa) {
    if (qa.value.answer1 == this.answer) {
      this.nav.navigateByUrl('/code/' + this.accid);
    }
    else if (qa.value.answer1 != this.answer) {
      this.toast.error(this.userService.translateText('patient_portal.display_messages.answer_not_match_account_blocked'), '', {
        timeOut: this.timealert
      })
      this.patientservice.getBlock(this.accid).subscribe(data => { });
      this.nav.navigateByUrl('/login');
    }
  }

}
